import { render, staticRenderFns } from "./PageOverlays.vue?vue&type=template&id=d93067f0"
import script from "./PageOverlays.vue?vue&type=script&lang=ts"
export * from "./PageOverlays.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports